/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * shariff - v3.0.1 - Tue, 17 Apr 2018 06:12:42 GMT
 * https://github.com/heiseonline/shariff
 * Copyright (c) 2018 Ines Pauer, Philipp Busse, Sebastian Hilbig, Erich Kramer, Deniz Sesli
 * Licensed under the MIT license
 */
!function (e) {
  function t(a) {
    if (r[a]) return r[a].exports;
    var n = r[a] = {
      i: a,
      l: !1,
      exports: {}
    };
    return e[a].call(n.exports, n, n.exports, t), n.l = !0, n.exports;
  }

  var r = {};
  t.m = e, t.c = r, t.d = function (e, r, a) {
    t.o(e, r) || Object.defineProperty(e, r, {
      configurable: !1,
      enumerable: !0,
      get: a
    });
  }, t.n = function (e) {
    var r = e && e.__esModule ? function () {
      return e["default"];
    } : function () {
      return e;
    };
    return t.d(r, "a", r), r;
  }, t.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, t.p = "", t(t.s = 2);
}([function (e, t, r) {
  "use strict";

  function a() {
    this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
  }

  function n(e, t, r) {
    if (e && p.isObject(e) && e instanceof a) return e;
    var n = new a();
    return n.parse(e, t, r), n;
  }

  function i(e) {
    return p.isString(e) && (e = n(e)), e instanceof a ? e.format() : a.prototype.format.call(e);
  }

  function o(e, t) {
    return n(e, !1, !0).resolve(t);
  }

  function s(e, t) {
    return e ? n(e, !1, !0).resolveObject(t) : t;
  }

  var l = r(9),
      p = r(11);
  t.parse = n, t.resolve = o, t.resolveObject = s, t.format = i, t.Url = a;
  var h = /^([a-z0-9.+-]+:)/i,
      u = /:[0-9]*$/,
      d = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
      c = ["<", ">", '"', "`", " ", "\r", "\n", "\t"],
      f = ["{", "}", "|", "\\", "^", "`"].concat(c),
      m = ["'"].concat(f),
      g = ["%", "/", "?", ";", "#"].concat(m),
      b = ["/", "?", "#"],
      v = /^[+a-z0-9A-Z_-]{0,63}$/,
      k = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
      j = {
    javascript: !0,
    "javascript:": !0
  },
      z = {
    javascript: !0,
    "javascript:": !0
  },
      y = {
    http: !0,
    https: !0,
    ftp: !0,
    gopher: !0,
    file: !0,
    "http:": !0,
    "https:": !0,
    "ftp:": !0,
    "gopher:": !0,
    "file:": !0
  },
      T = r(12);
  a.prototype.parse = function (e, t, r) {
    if (!p.isString(e)) throw new TypeError("Parameter 'url' must be a string, not " + _typeof(e));
    var a = e.indexOf("?"),
        n = -1 !== a && a < e.indexOf("#") ? "?" : "#",
        i = e.split(n),
        o = /\\/g;
    i[0] = i[0].replace(o, "/"), e = i.join(n);
    var s = e;

    if (s = s.trim(), !r && 1 === e.split("#").length) {
      var u = d.exec(s);
      if (u) return this.path = s, this.href = s, this.pathname = u[1], u[2] ? (this.search = u[2], this.query = t ? T.parse(this.search.substr(1)) : this.search.substr(1)) : t && (this.search = "", this.query = {}), this;
    }

    var c = h.exec(s);

    if (c) {
      c = c[0];
      var f = c.toLowerCase();
      this.protocol = f, s = s.substr(c.length);
    }

    if (r || c || s.match(/^\/\/[^@\/]+@[^@\/]+/)) {
      var w = "//" === s.substr(0, 2);
      !w || c && z[c] || (s = s.substr(2), this.slashes = !0);
    }

    if (!z[c] && (w || c && !y[c])) {
      for (var P = -1, x = 0; x < b.length; x++) {
        var D = s.indexOf(b[x]);
        -1 !== D && (-1 === P || D < P) && (P = D);
      }

      var U, C;
      C = -1 === P ? s.lastIndexOf("@") : s.lastIndexOf("@", P), -1 !== C && (U = s.slice(0, C), s = s.slice(C + 1), this.auth = decodeURIComponent(U)), P = -1;

      for (var x = 0; x < g.length; x++) {
        var D = s.indexOf(g[x]);
        -1 !== D && (-1 === P || D < P) && (P = D);
      }

      -1 === P && (P = s.length), this.host = s.slice(0, P), s = s.slice(P), this.parseHost(), this.hostname = this.hostname || "";
      var R = "[" === this.hostname[0] && "]" === this.hostname[this.hostname.length - 1];
      if (!R) for (var I = this.hostname.split(/\./), x = 0, S = I.length; x < S; x++) {
        var L = I[x];

        if (L && !L.match(v)) {
          for (var F = "", N = 0, O = L.length; N < O; N++) {
            L.charCodeAt(N) > 127 ? F += "x" : F += L[N];
          }

          if (!F.match(v)) {
            var A = I.slice(0, x),
                G = I.slice(x + 1),
                q = L.match(k);
            q && (A.push(q[1]), G.unshift(q[2])), G.length && (s = "/" + G.join(".") + s), this.hostname = A.join(".");
            break;
          }
        }
      }
      this.hostname.length > 255 ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), R || (this.hostname = l.toASCII(this.hostname));
      var M = this.port ? ":" + this.port : "",
          J = this.hostname || "";
      this.host = J + M, this.href += this.host, R && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), "/" !== s[0] && (s = "/" + s));
    }

    if (!j[f]) for (var x = 0, S = m.length; x < S; x++) {
      var V = m[x];

      if (-1 !== s.indexOf(V)) {
        var W = encodeURIComponent(V);
        W === V && (W = escape(V)), s = s.split(V).join(W);
      }
    }
    var Q = s.indexOf("#");
    -1 !== Q && (this.hash = s.substr(Q), s = s.slice(0, Q));
    var B = s.indexOf("?");

    if (-1 !== B ? (this.search = s.substr(B), this.query = s.substr(B + 1), t && (this.query = T.parse(this.query)), s = s.slice(0, B)) : t && (this.search = "", this.query = {}), s && (this.pathname = s), y[f] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
      var M = this.pathname || "",
          X = this.search || "";
      this.path = M + X;
    }

    return this.href = this.format(), this;
  }, a.prototype.format = function () {
    var e = this.auth || "";
    e && (e = encodeURIComponent(e), e = e.replace(/%3A/i, ":"), e += "@");
    var t = this.protocol || "",
        r = this.pathname || "",
        a = this.hash || "",
        n = !1,
        i = "";
    this.host ? n = e + this.host : this.hostname && (n = e + (-1 === this.hostname.indexOf(":") ? this.hostname : "[" + this.hostname + "]"), this.port && (n += ":" + this.port)), this.query && p.isObject(this.query) && Object.keys(this.query).length && (i = T.stringify(this.query));
    var o = this.search || i && "?" + i || "";
    return t && ":" !== t.substr(-1) && (t += ":"), this.slashes || (!t || y[t]) && !1 !== n ? (n = "//" + (n || ""), r && "/" !== r.charAt(0) && (r = "/" + r)) : n || (n = ""), a && "#" !== a.charAt(0) && (a = "#" + a), o && "?" !== o.charAt(0) && (o = "?" + o), r = r.replace(/[?#]/g, function (e) {
      return encodeURIComponent(e);
    }), o = o.replace("#", "%23"), t + n + r + o + a;
  }, a.prototype.resolve = function (e) {
    return this.resolveObject(n(e, !1, !0)).format();
  }, a.prototype.resolveObject = function (e) {
    if (p.isString(e)) {
      var t = new a();
      t.parse(e, !1, !0), e = t;
    }

    for (var r = new a(), n = Object.keys(this), i = 0; i < n.length; i++) {
      var o = n[i];
      r[o] = this[o];
    }

    if (r.hash = e.hash, "" === e.href) return r.href = r.format(), r;

    if (e.slashes && !e.protocol) {
      for (var s = Object.keys(e), l = 0; l < s.length; l++) {
        var h = s[l];
        "protocol" !== h && (r[h] = e[h]);
      }

      return y[r.protocol] && r.hostname && !r.pathname && (r.path = r.pathname = "/"), r.href = r.format(), r;
    }

    if (e.protocol && e.protocol !== r.protocol) {
      if (!y[e.protocol]) {
        for (var u = Object.keys(e), d = 0; d < u.length; d++) {
          var c = u[d];
          r[c] = e[c];
        }

        return r.href = r.format(), r;
      }

      if (r.protocol = e.protocol, e.host || z[e.protocol]) r.pathname = e.pathname;else {
        for (var f = (e.pathname || "").split("/"); f.length && !(e.host = f.shift());) {
          ;
        }

        e.host || (e.host = ""), e.hostname || (e.hostname = ""), "" !== f[0] && f.unshift(""), f.length < 2 && f.unshift(""), r.pathname = f.join("/");
      }

      if (r.search = e.search, r.query = e.query, r.host = e.host || "", r.auth = e.auth, r.hostname = e.hostname || e.host, r.port = e.port, r.pathname || r.search) {
        var m = r.pathname || "",
            g = r.search || "";
        r.path = m + g;
      }

      return r.slashes = r.slashes || e.slashes, r.href = r.format(), r;
    }

    var b = r.pathname && "/" === r.pathname.charAt(0),
        v = e.host || e.pathname && "/" === e.pathname.charAt(0),
        k = v || b || r.host && e.pathname,
        j = k,
        T = r.pathname && r.pathname.split("/") || [],
        f = e.pathname && e.pathname.split("/") || [],
        w = r.protocol && !y[r.protocol];
    if (w && (r.hostname = "", r.port = null, r.host && ("" === T[0] ? T[0] = r.host : T.unshift(r.host)), r.host = "", e.protocol && (e.hostname = null, e.port = null, e.host && ("" === f[0] ? f[0] = e.host : f.unshift(e.host)), e.host = null), k = k && ("" === f[0] || "" === T[0])), v) r.host = e.host || "" === e.host ? e.host : r.host, r.hostname = e.hostname || "" === e.hostname ? e.hostname : r.hostname, r.search = e.search, r.query = e.query, T = f;else if (f.length) T || (T = []), T.pop(), T = T.concat(f), r.search = e.search, r.query = e.query;else if (!p.isNullOrUndefined(e.search)) {
      if (w) {
        r.hostname = r.host = T.shift();
        var P = !!(r.host && r.host.indexOf("@") > 0) && r.host.split("@");
        P && (r.auth = P.shift(), r.host = r.hostname = P.shift());
      }

      return r.search = e.search, r.query = e.query, p.isNull(r.pathname) && p.isNull(r.search) || (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.href = r.format(), r;
    }
    if (!T.length) return r.pathname = null, r.search ? r.path = "/" + r.search : r.path = null, r.href = r.format(), r;

    for (var x = T.slice(-1)[0], D = (r.host || e.host || T.length > 1) && ("." === x || ".." === x) || "" === x, U = 0, C = T.length; C >= 0; C--) {
      x = T[C], "." === x ? T.splice(C, 1) : ".." === x ? (T.splice(C, 1), U++) : U && (T.splice(C, 1), U--);
    }

    if (!k && !j) for (; U--; U) {
      T.unshift("..");
    }
    !k || "" === T[0] || T[0] && "/" === T[0].charAt(0) || T.unshift(""), D && "/" !== T.join("/").substr(-1) && T.push("");
    var R = "" === T[0] || T[0] && "/" === T[0].charAt(0);

    if (w) {
      r.hostname = r.host = R ? "" : T.length ? T.shift() : "";
      var P = !!(r.host && r.host.indexOf("@") > 0) && r.host.split("@");
      P && (r.auth = P.shift(), r.host = r.hostname = P.shift());
    }

    return k = k || r.host && T.length, k && !R && T.unshift(""), T.length ? r.pathname = T.join("/") : (r.pathname = null, r.path = null), p.isNull(r.pathname) && p.isNull(r.search) || (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.auth = e.auth || r.auth, r.slashes = r.slashes || e.slashes, r.href = r.format(), r;
  }, a.prototype.parseHost = function () {
    var e = this.host,
        t = u.exec(e);
    t && (t = t[0], ":" !== t && (this.port = t.substr(1)), e = e.substr(0, e.length - t.length)), e && (this.hostname = e);
  };
}, function (e, t) {
  var r;

  r = function () {
    return this;
  }();

  try {
    r = r || Function("return this")() || (0, eval)("this");
  } catch (e) {
    "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && (r = window);
  }

  e.exports = r;
}, function (e, t, r) {
  "use strict";

  r(3), e.exports = r(4);
}, function (e, t) {}, function (e, t, r) {
  "use strict";

  (function (t) {
    function a(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    var n = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
    },
        i = function () {
      function e(e, t) {
        for (var r = 0; r < t.length; r++) {
          var a = t[r];
          a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
        }
      }

      return function (t, r, a) {
        return r && e(t.prototype, r), a && e(t, a), t;
      };
    }(),
        o = r(5),
        s = r(6),
        l = r(0),
        p = {
      theme: "color",
      backendUrl: null,
      infoUrl: "http://ct.de/-2467514",
      infoDisplay: "blank",
      lang: "de",
      langFallback: "en",
      mailUrl: function mailUrl() {
        var e = l.parse(this.getURL(), !0);
        return e.query.view = "mail", delete e.search, l.format(e);
      },
      mailBody: function mailBody() {
        return this.getURL();
      },
      mediaUrl: null,
      orientation: "horizontal",
      buttonStyle: "standard",
      referrerTrack: null,
      services: ["twitter", "facebook", "googleplus", "info"],
      title: t.document.title,
      twitterVia: null,
      flattrUser: null,
      flattrCategory: null,
      url: function url() {
        var e = t.document.location.href,
            r = o("link[rel=canonical]").attr("href") || this.getMeta("og:url") || "";
        return r.length > 0 && (r.indexOf("http") < 0 && (r = t.document.location.protocol + "//" + t.document.location.host + r), e = r), e;
      }
    },
        h = function () {
      function e(t, r) {
        var n = this;
        a(this, e), this.element = t, o(t).empty(), this.options = o.extend({}, p, r, o(t).data()), this.services = Object.keys(s).filter(function (e) {
          return n.isEnabledService(e);
        }).sort(function (e, t) {
          var r = n.options.services;
          return r.indexOf(e) - r.indexOf(t);
        }).map(function (e) {
          return s[e](n);
        }), this._addButtonList(), null !== this.options.backendUrl && "icon" !== this.options.buttonStyle && this.getShares(this._updateCounts.bind(this));
      }

      return i(e, [{
        key: "isEnabledService",
        value: function value(e) {
          return this.options.services.indexOf(e) > -1;
        }
      }, {
        key: "$socialshareElement",
        value: function value() {
          return o(this.element);
        }
      }, {
        key: "getLocalized",
        value: function value(e, t) {
          return "object" === n(e[t]) ? void 0 === e[t][this.options.lang] ? e[t][this.options.langFallback] : e[t][this.options.lang] : "string" == typeof e[t] ? e[t] : void 0;
        }
      }, {
        key: "getMeta",
        value: function value(e) {
          return o('meta[name="' + e + '"],[property="' + e + '"]').attr("content") || "";
        }
      }, {
        key: "getInfoUrl",
        value: function value() {
          return this.options.infoUrl;
        }
      }, {
        key: "getInfoDisplayPopup",
        value: function value() {
          return "popup" === this.options.infoDisplay;
        }
      }, {
        key: "getInfoDisplayBlank",
        value: function value() {
          return "popup" !== this.options.infoDisplay && "self" !== this.options.infoDisplay;
        }
      }, {
        key: "getURL",
        value: function value() {
          return this.getOption("url");
        }
      }, {
        key: "getOption",
        value: function value(e) {
          var t = this.options[e];
          return "function" == typeof t ? t.call(this) : t;
        }
      }, {
        key: "getTitle",
        value: function value() {
          var e = this.getOption("title") || this.getMeta("DC.title"),
              t = this.getMeta("DC.creator");
          return e && t && (e = e + " - " + t), e;
        }
      }, {
        key: "getReferrerTrack",
        value: function value() {
          return this.options.referrerTrack || "";
        }
      }, {
        key: "getShares",
        value: function value(e) {
          var t = l.parse(this.options.backendUrl, !0);
          return t.query.url = this.getURL(), delete t.search, o.getJSON(l.format(t), e);
        }
      }, {
        key: "_updateCounts",
        value: function value(e, t, r) {
          var a = this;
          e && o.each(e, function (e, t) {
            a.isEnabledService(e) && (t >= 1e3 && (t = Math.round(t / 1e3) + "k"), o(a.element).find("." + e + " a").append(o("<span/>").addClass("share_count").text(t)));
          });
        }
      }, {
        key: "_addButtonList",
        value: function value() {
          var e = this,
              r = o("<ul/>").addClass(["theme-" + this.options.theme, "orientation-" + this.options.orientation, "button-style-" + this.options.buttonStyle, "shariff-col-" + this.options.services.length].join(" "));
          this.services.forEach(function (t) {
            var a = o("<li/>").addClass("shariff-button " + t.name),
                n = o("<a/>").attr("href", t.shareUrl);

            if ("standard" === e.options.buttonStyle) {
              var i = o("<span/>").addClass("share_text").text(e.getLocalized(t, "shareText"));
              n.append(i);
            }

            void 0 !== t.faPrefix && void 0 !== t.faName && n.prepend(o("<span/>").addClass(t.faPrefix + " " + t.faName)), t.popup ? (n.attr("data-rel", "popup"), "info" !== t.name && n.attr("rel", "nofollow")) : t.blank ? (n.attr("target", "_blank"), "info" === t.name ? n.attr("rel", "noopener noreferrer") : n.attr("rel", "nofollow noopener noreferrer")) : "info" !== t.name && n.attr("rel", "nofollow"), n.attr("title", e.getLocalized(t, "title")), n.attr("role", "button"), n.attr("aria-label", e.getLocalized(t, "title")), a.append(n), r.append(a);
          }), r.on("click", '[data-rel="popup"]', function (e) {
            e.preventDefault();
            var r = o(this).attr("href");

            if (r.match(/twitter\.com\/intent\/(\w+)/)) {
              var a = t.window;
              if (a.__twttr && a.__twttr.widgets && a.__twttr.widgets.loaded) return;
            }

            t.window.open(r, "_blank", "width=600,height=460");
          }), this.$socialshareElement().append(r);
        }
      }]), e;
    }();

    e.exports = h, t.Shariff = h, o(function () {
      o(".shariff").each(function () {
        this.hasOwnProperty("shariff") || (this.shariff = new h(this));
      });
    });
  }).call(t, r(1));
}, function (e, t) {
  e.exports = jQuery;
}, function (e, t, r) {
  "use strict";

  e.exports = {
    addthis: r(7),
    diaspora: r(8),
    facebook: r(15),
    flattr: r(16),
    flipboard: r(17),
    googleplus: r(18),
    info: r(19),
    linkedin: r(20),
    mail: r(21),
    pinterest: r(22),
    print: r(23),
    qzone: r(24),
    reddit: r(25),
    stumbleupon: r(26),
    telegram: r(27),
    tencent: r(28),
    threema: r(29),
    tumblr: r(30),
    twitter: r(31),
    vk: r(32),
    weibo: r(33),
    whatsapp: r(34),
    xing: r(35)
  };
}, function (e, t, r) {
  "use strict";

  e.exports = function (e) {
    return {
      popup: !0,
      shareText: {
        bg: "cподеляне",
        cs: "sdílet",
        da: "del",
        de: "teilen",
        en: "share",
        es: "compartir",
        fi: "Jaa",
        fr: "partager",
        hr: "podijelite",
        hu: "megosztás",
        it: "condividi",
        ja: "共有",
        ko: "공유하기",
        nl: "delen",
        no: "del",
        pl: "udostępnij",
        pt: "compartilhar",
        ro: "partajează",
        ru: "поделиться",
        sk: "zdieľať",
        sl: "deli",
        sr: "podeli",
        sv: "dela",
        tr: "paylaş",
        zh: "分享"
      },
      name: "addthis",
      faPrefix: "fas",
      faName: "fa-plus",
      title: {
        bg: "Сподели в AddThis",
        cs: "Sdílet na AddThis",
        da: "Del på AddThis",
        de: "Bei AddThis teilen",
        en: "Share on AddThis",
        es: "Compartir en AddThis",
        fi: "Jaa AddThisissä",
        fr: "Partager sur AddThis",
        hr: "Podijelite na AddThis",
        hu: "Megosztás AddThisen",
        it: "Condividi su AddThis",
        ja: "AddThis上で共有",
        ko: "AddThis에서 공유하기",
        nl: "Delen op AddThis",
        no: "Del på AddThis",
        pl: "Udostępnij przez AddThis",
        pt: "Compartilhar no AddThis",
        ro: "Partajează pe AddThis",
        ru: "Поделиться на AddThis",
        sk: "Zdieľať na AddThis",
        sl: "Deli na AddThis",
        sr: "Podeli na AddThis",
        sv: "Dela på AddThis",
        tr: "AddThis'ta paylaş",
        zh: "在AddThis上分享"
      },
      shareUrl: "http://api.addthis.com/oexchange/0.8/offer?url=" + encodeURIComponent(e.getURL()) + e.getReferrerTrack()
    };
  };
}, function (e, t, r) {
  "use strict";

  var a = r(0);

  e.exports = function (e) {
    var t = a.parse("https://share.diasporafoundation.org/", !0);
    return t.query.url = e.getURL(), t.query.title = e.getTitle(), t.protocol = "https", delete t.search, {
      popup: !0,
      shareText: {
        bg: "cподеляне",
        cs: "sdílet",
        da: "del",
        de: "teilen",
        en: "share",
        es: "compartir",
        fi: "Jaa",
        fr: "partager",
        hr: "podijelite",
        hu: "megosztás",
        it: "condividi",
        ja: "共有",
        ko: "공유하기",
        nl: "delen",
        no: "del",
        pl: "udostępnij",
        pt: "compartilhar",
        ro: "partajează",
        ru: "поделиться",
        sk: "zdieľať",
        sl: "deli",
        sr: "podeli",
        sv: "dela",
        tr: "paylaş",
        zh: "分享"
      },
      name: "diaspora",
      faPrefix: "fas",
      faName: "fa-asterisk",
      title: {
        bg: "Сподели в Diaspora",
        cs: "Sdílet na Diaspora",
        da: "Del på Diaspora",
        de: "Bei Diaspora teilen",
        en: "Share on Diaspora",
        es: "Compartir en Diaspora",
        fi: "Jaa Diasporaissä",
        fr: "Partager sur Diaspora",
        hr: "Podijelite na Diaspora",
        hu: "Megosztás Diaspora",
        it: "Condividi su Diaspora",
        ja: "Diaspora上で共有",
        ko: "Diaspora에서 공유하기",
        nl: "Delen op Diaspora",
        no: "Del på Diaspora",
        pl: "Udostępnij przez Diaspora",
        pt: "Compartilhar no Diaspora",
        ro: "Partajează pe Diaspora",
        ru: "Поделиться на Diaspora",
        sk: "Zdieľať na Diaspora",
        sl: "Deli na Diaspora",
        sr: "Podeli na Diaspora-u",
        sv: "Dela på Diaspora",
        tr: "Diaspora'ta paylaş",
        zh: "分享至Diaspora"
      },
      shareUrl: a.format(t) + e.getReferrerTrack()
    };
  };
}, function (e, t, r) {
  (function (e, a) {
    var n;
    !function (a) {
      function i(e) {
        throw new RangeError(R[e]);
      }

      function o(e, t) {
        for (var r = e.length, a = []; r--;) {
          a[r] = t(e[r]);
        }

        return a;
      }

      function s(e, t) {
        var r = e.split("@"),
            a = "";
        return r.length > 1 && (a = r[0] + "@", e = r[1]), e = e.replace(C, "."), a + o(e.split("."), t).join(".");
      }

      function l(e) {
        for (var t, r, a = [], n = 0, i = e.length; n < i;) {
          t = e.charCodeAt(n++), t >= 55296 && t <= 56319 && n < i ? (r = e.charCodeAt(n++), 56320 == (64512 & r) ? a.push(((1023 & t) << 10) + (1023 & r) + 65536) : (a.push(t), n--)) : a.push(t);
        }

        return a;
      }

      function p(e) {
        return o(e, function (e) {
          var t = "";
          return e > 65535 && (e -= 65536, t += L(e >>> 10 & 1023 | 55296), e = 56320 | 1023 & e), t += L(e);
        }).join("");
      }

      function h(e) {
        return e - 48 < 10 ? e - 22 : e - 65 < 26 ? e - 65 : e - 97 < 26 ? e - 97 : k;
      }

      function u(e, t) {
        return e + 22 + 75 * (e < 26) - ((0 != t) << 5);
      }

      function d(e, t, r) {
        var a = 0;

        for (e = r ? S(e / T) : e >> 1, e += S(e / t); e > I * z >> 1; a += k) {
          e = S(e / I);
        }

        return S(a + (I + 1) * e / (e + y));
      }

      function c(e) {
        var t,
            r,
            a,
            n,
            o,
            s,
            l,
            u,
            c,
            f,
            m = [],
            g = e.length,
            b = 0,
            y = P,
            T = w;

        for (r = e.lastIndexOf(x), r < 0 && (r = 0), a = 0; a < r; ++a) {
          e.charCodeAt(a) >= 128 && i("not-basic"), m.push(e.charCodeAt(a));
        }

        for (n = r > 0 ? r + 1 : 0; n < g;) {
          for (o = b, s = 1, l = k; n >= g && i("invalid-input"), u = h(e.charCodeAt(n++)), (u >= k || u > S((v - b) / s)) && i("overflow"), b += u * s, c = l <= T ? j : l >= T + z ? z : l - T, !(u < c); l += k) {
            f = k - c, s > S(v / f) && i("overflow"), s *= f;
          }

          t = m.length + 1, T = d(b - o, t, 0 == o), S(b / t) > v - y && i("overflow"), y += S(b / t), b %= t, m.splice(b++, 0, y);
        }

        return p(m);
      }

      function f(e) {
        var t,
            r,
            a,
            n,
            o,
            s,
            p,
            h,
            c,
            f,
            m,
            g,
            b,
            y,
            T,
            D = [];

        for (e = l(e), g = e.length, t = P, r = 0, o = w, s = 0; s < g; ++s) {
          (m = e[s]) < 128 && D.push(L(m));
        }

        for (a = n = D.length, n && D.push(x); a < g;) {
          for (p = v, s = 0; s < g; ++s) {
            (m = e[s]) >= t && m < p && (p = m);
          }

          for (b = a + 1, p - t > S((v - r) / b) && i("overflow"), r += (p - t) * b, t = p, s = 0; s < g; ++s) {
            if (m = e[s], m < t && ++r > v && i("overflow"), m == t) {
              for (h = r, c = k; f = c <= o ? j : c >= o + z ? z : c - o, !(h < f); c += k) {
                T = h - f, y = k - f, D.push(L(u(f + T % y, 0))), h = S(T / y);
              }

              D.push(L(u(h, 0))), o = d(r, b, a == n), r = 0, ++a;
            }
          }

          ++r, ++t;
        }

        return D.join("");
      }

      function m(e) {
        return s(e, function (e) {
          return D.test(e) ? c(e.slice(4).toLowerCase()) : e;
        });
      }

      function g(e) {
        return s(e, function (e) {
          return U.test(e) ? "xn--" + f(e) : e;
        });
      }

      var b,
          v = ("object" == _typeof(t) && t && t.nodeType, "object" == _typeof(e) && e && e.nodeType, 2147483647),
          k = 36,
          j = 1,
          z = 26,
          y = 38,
          T = 700,
          w = 72,
          P = 128,
          x = "-",
          D = /^xn--/,
          U = /[^\x20-\x7E]/,
          C = /[\x2E\u3002\uFF0E\uFF61]/g,
          R = {
        overflow: "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
      },
          I = k - j,
          S = Math.floor,
          L = String.fromCharCode;
      b = {
        version: "1.4.1",
        ucs2: {
          decode: l,
          encode: p
        },
        decode: c,
        encode: f,
        toASCII: g,
        toUnicode: m
      }, void 0 !== (n = function () {
        return b;
      }.call(t, r, t, e)) && (e.exports = n);
    }();
  }).call(t, r(10)(e), r(1));
}, function (e, t) {
  e.exports = function (e) {
    return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
      enumerable: !0,
      get: function get() {
        return e.l;
      }
    }), Object.defineProperty(e, "id", {
      enumerable: !0,
      get: function get() {
        return e.i;
      }
    }), e.webpackPolyfill = 1), e;
  };
}, function (e, t, r) {
  "use strict";

  e.exports = {
    isString: function isString(e) {
      return "string" == typeof e;
    },
    isObject: function isObject(e) {
      return "object" == _typeof(e) && null !== e;
    },
    isNull: function isNull(e) {
      return null === e;
    },
    isNullOrUndefined: function isNullOrUndefined(e) {
      return null == e;
    }
  };
}, function (e, t, r) {
  "use strict";

  t.decode = t.parse = r(13), t.encode = t.stringify = r(14);
}, function (e, t, r) {
  "use strict";

  function a(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }

  e.exports = function (e, t, r, i) {
    t = t || "&", r = r || "=";
    var o = {};
    if ("string" != typeof e || 0 === e.length) return o;
    var s = /\+/g;
    e = e.split(t);
    var l = 1e3;
    i && "number" == typeof i.maxKeys && (l = i.maxKeys);
    var p = e.length;
    l > 0 && p > l && (p = l);

    for (var h = 0; h < p; ++h) {
      var u,
          d,
          c,
          f,
          m = e[h].replace(s, "%20"),
          g = m.indexOf(r);
      g >= 0 ? (u = m.substr(0, g), d = m.substr(g + 1)) : (u = m, d = ""), c = decodeURIComponent(u), f = decodeURIComponent(d), a(o, c) ? n(o[c]) ? o[c].push(f) : o[c] = [o[c], f] : o[c] = f;
    }

    return o;
  };

  var n = Array.isArray || function (e) {
    return "[object Array]" === Object.prototype.toString.call(e);
  };
}, function (e, t, r) {
  "use strict";

  function a(e, t) {
    if (e.map) return e.map(t);

    for (var r = [], a = 0; a < e.length; a++) {
      r.push(t(e[a], a));
    }

    return r;
  }

  var n = function n(e) {
    switch (_typeof(e)) {
      case "string":
        return e;

      case "boolean":
        return e ? "true" : "false";

      case "number":
        return isFinite(e) ? e : "";

      default:
        return "";
    }
  };

  e.exports = function (e, t, r, s) {
    return t = t || "&", r = r || "=", null === e && (e = void 0), "object" == _typeof(e) ? a(o(e), function (o) {
      var s = encodeURIComponent(n(o)) + r;
      return i(e[o]) ? a(e[o], function (e) {
        return s + encodeURIComponent(n(e));
      }).join(t) : s + encodeURIComponent(n(e[o]));
    }).join(t) : s ? encodeURIComponent(n(s)) + r + encodeURIComponent(n(e)) : "";
  };

  var i = Array.isArray || function (e) {
    return "[object Array]" === Object.prototype.toString.call(e);
  },
      o = Object.keys || function (e) {
    var t = [];

    for (var r in e) {
      Object.prototype.hasOwnProperty.call(e, r) && t.push(r);
    }

    return t;
  };
}, function (e, t, r) {
  "use strict";

  e.exports = function (e) {
    return {
      popup: !0,
      shareText: {
        bg: "cподеляне",
        cs: "sdílet",
        da: "del",
        de: "teilen",
        en: "share",
        es: "compartir",
        fi: "Jaa",
        fr: "partager",
        hr: "podijelite",
        hu: "megosztás",
        it: "condividi",
        ja: "共有",
        ko: "공유하기",
        nl: "delen",
        no: "del",
        pl: "udostępnij",
        pt: "compartilhar",
        ro: "partajează",
        ru: "поделиться",
        sk: "zdieľať",
        sl: "deli",
        sr: "podeli",
        sv: "dela",
        tr: "paylaş",
        zh: "分享"
      },
      name: "facebook",
      faPrefix: "fab",
      faName: "fa-facebook-f",
      title: {
        bg: "Сподели във Facebook",
        cs: "Sdílet na Facebooku",
        da: "Del på Facebook",
        de: "Bei Facebook teilen",
        en: "Share on Facebook",
        es: "Compartir en Facebook",
        fi: "Jaa Facebookissa",
        fr: "Partager sur Facebook",
        hr: "Podijelite na Facebooku",
        hu: "Megosztás Facebookon",
        it: "Condividi su Facebook",
        ja: "フェイスブック上で共有",
        ko: "페이스북에서 공유하기",
        nl: "Delen op Facebook",
        no: "Del på Facebook",
        pl: "Udostępnij na Facebooku",
        pt: "Compartilhar no Facebook",
        ro: "Partajează pe Facebook",
        ru: "Поделиться на Facebook",
        sk: "Zdieľať na Facebooku",
        sl: "Deli na Facebooku",
        sr: "Podeli na Facebook-u",
        sv: "Dela på Facebook",
        tr: "Facebook'ta paylaş",
        zh: "在Facebook上分享"
      },
      shareUrl: "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(e.getURL()) + e.getReferrerTrack()
    };
  };
}, function (e, t, r) {
  "use strict";

  e.exports = function (e) {
    var t = encodeURIComponent(e.getURL()),
        r = e.getTitle(),
        a = e.getMeta("description");
    return {
      popup: !0,
      shareText: "Flattr",
      name: "flattr",
      faPrefix: "far",
      faName: "fa-money-bill-alt",
      title: {
        de: "Artikel flattrn",
        en: "Flattr this"
      },
      shareUrl: "https://flattr.com/submit/auto?title=" + encodeURIComponent(r) + "&description=" + encodeURIComponent(a) + "&category=" + encodeURIComponent(e.options.flattrCategory || "text") + "&user_id=" + encodeURIComponent(e.options.flattrUser) + "&url=" + t + e.getReferrerTrack()
    };
  };
}, function (e, t, r) {
  "use strict";

  e.exports = function (e) {
    var t = encodeURIComponent(e.getURL());
    return {
      popup: !0,
      shareText: "flip it",
      name: "flipboard",
      faPrefix: "fab",
      faName: "fa-flipboard",
      title: {
        bg: "Сподели в Flipboard",
        cs: "Sdílet na Flipboardu",
        da: "Del på Flipboard",
        de: "Bei Flipboard teilen",
        en: "Share on Flipboard",
        es: "Compartir en Flipboard",
        fi: "Jaa Flipboardissä",
        fr: "Partager sur Flipboard",
        hr: "Podijelite na Flipboardu",
        hu: "Megosztás Flipboardon",
        it: "Condividi su Flipboard",
        ja: "Flipboard上で共有",
        ko: "Flipboard에서 공유하기",
        nl: "Delen op Flipboard",
        no: "Del på Flipboard",
        pl: "Udostępnij na Flipboardu",
        pt: "Compartilhar no Flipboard",
        ro: "Partajează pe Flipboard",
        ru: "Поделиться на Flipboard",
        sk: "Zdieľať na Flipboardu",
        sl: "Deli na Flipboardu",
        sr: "Podeli na Flipboard-u",
        sv: "Dela på Flipboard",
        tr: "Flipboard'ta paylaş",
        zh: "在Flipboard上分享"
      },
      shareUrl: "https://share.flipboard.com/bookmarklet/popout?v=2&title=" + encodeURIComponent(e.getTitle()) + "&url=" + t + e.getReferrerTrack()
    };
  };
}, function (e, t, r) {
  "use strict";

  e.exports = function (e) {
    return {
      popup: !0,
      shareText: {
        bg: "cподеляне",
        cs: "sdílet",
        da: "del",
        de: "teilen",
        en: "share",
        es: "compartir",
        fi: "Jaa",
        fr: "partager",
        hr: "podijelite",
        hu: "megosztás",
        it: "condividi",
        ja: "共有",
        ko: "공유하기",
        nl: "delen",
        no: "del",
        pl: "udostępnij",
        pt: "compartilhar",
        ro: "partajează",
        ru: "поделиться",
        sk: "zdieľať",
        sl: "deli",
        sr: "podeli",
        sv: "dela",
        tr: "paylaş",
        zh: "分享"
      },
      name: "googleplus",
      faPrefix: "fab",
      faName: "fa-google-plus-g",
      title: {
        bg: "Сподели в Google+",
        cs: "Sdílet na Google+",
        da: "Del på Google+",
        de: "Bei Google+ teilen",
        en: "Share on Google+",
        es: "Compartir en Google+",
        fi: "Jaa Google+:ssa",
        fr: "Partager sur Goolge+",
        hr: "Podijelite na Google+",
        hu: "Megosztás Google+on",
        it: "Condividi su Google+",
        ja: "Google+上で共有",
        ko: "Google+에서 공유하기",
        nl: "Delen op Google+",
        no: "Del på Google+",
        pl: "Udostępnij na Google+",
        pt: "Compartilhar no Google+",
        ro: "Partajează pe Google+",
        ru: "Поделиться на Google+",
        sk: "Zdieľať na Google+",
        sl: "Deli na Google+",
        sr: "Podeli na Google+",
        sv: "Dela på Google+",
        tr: "Google+'da paylaş",
        zh: "在Google+上分享"
      },
      shareUrl: "https://plus.google.com/share?url=" + encodeURIComponent(e.getURL()) + e.getReferrerTrack()
    };
  };
}, function (e, t, r) {
  "use strict";

  e.exports = function (e) {
    return {
      blank: e.getInfoDisplayBlank(),
      popup: e.getInfoDisplayPopup(),
      shareText: "Info",
      name: "info",
      faPrefix: "fas",
      faName: "fa-info",
      title: {
        bg: "Повече информация",
        cs: "Více informací",
        da: "Flere oplysninger",
        de: "Weitere Informationen",
        en: "More information",
        es: "Más informaciones",
        fi: "Lisätietoja",
        fr: "Plus d'informations",
        hr: "Više informacija",
        hu: "Több információ",
        it: "Maggiori informazioni",
        ja: "詳しい情報",
        ko: "추가 정보",
        nl: "Verdere informatie",
        no: "Mer informasjon",
        pl: "Więcej informacji",
        pt: "Mais informações",
        ro: "Mai multe informatii",
        ru: "Больше информации",
        sk: "Viac informácií",
        sl: "Več informacij",
        sr: "Više informacija",
        sv: "Mer information",
        tr: "Daha fazla bilgi",
        zh: "更多信息"
      },
      shareUrl: e.getInfoUrl()
    };
  };
}, function (e, t, r) {
  "use strict";

  e.exports = function (e) {
    var t = encodeURIComponent(e.getURL()),
        r = encodeURIComponent(e.getTitle());
    return {
      popup: !0,
      shareText: {
        bg: "cподеляне",
        cs: "sdílet",
        da: "del",
        de: "mitteilen",
        en: "share",
        es: "compartir",
        fi: "Jaa",
        fr: "partager",
        hr: "podijelite",
        hu: "megosztás",
        it: "condividi",
        ja: "シェア",
        ko: "공유하기",
        nl: "delen",
        no: "del",
        pl: "udostępnij",
        pt: "compartilhar",
        ro: "distribuiți",
        ru: "поделиться",
        sk: "zdieľať",
        sl: "deli",
        sr: "podeli",
        sv: "dela",
        tr: "paylaş",
        zh: "分享"
      },
      name: "linkedin",
      faPrefix: "fab",
      faName: "fa-linkedin-in",
      title: {
        bg: "Сподели в LinkedIn",
        cs: "Sdílet na LinkedIn",
        da: "Del på LinkedIn",
        de: "Bei LinkedIn teilen",
        en: "Share on LinkedIn",
        es: "Compartir en LinkedIn",
        fi: "Jaa LinkedInissä",
        fr: "Partager sur LinkedIn",
        hr: "Podijelite na LinkedIn",
        hu: "Megosztás LinkedInen",
        it: "Condividi su LinkedIn",
        ja: "LinkedIn上で共有",
        ko: "LinkedIn에서 공유하기",
        nl: "Delen op LinkedIn",
        no: "Del på LinkedIn",
        pl: "Udostępnij przez LinkedIn",
        pt: "Compartilhar no LinkedIn",
        ro: "Partajează pe LinkedIn",
        ru: "Поделиться на LinkedIn",
        sk: "Zdieľať na LinkedIn",
        sl: "Deli na LinkedIn",
        sr: "Podeli na LinkedIn-u",
        sv: "Dela på LinkedIn",
        tr: "LinkedIn'ta paylaş",
        zh: "在LinkedIn上分享"
      },
      shareUrl: "https://www.linkedin.com/shareArticle?mini=true&summary=" + encodeURIComponent(e.getMeta("description")) + "&title=" + r + "&url=" + t
    };
  };
}, function (e, t, r) {
  "use strict";

  e.exports = function (e) {
    var t = e.getOption("mailUrl");
    return 0 === t.indexOf("mailto:") && (t += "?subject=" + encodeURIComponent(e.getOption("mailSubject") || e.getTitle()), t += "&body=" + encodeURIComponent(e.getOption("mailBody").replace(/\{url\}/i, e.getURL()))), {
      blank: 0 === t.indexOf("http"),
      popup: !1,
      shareText: {
        en: "mail",
        zh: "分享"
      },
      name: "mail",
      faPrefix: "fas",
      faName: "fa-envelope",
      title: {
        bg: "Изпрати по имейл",
        cs: "Poslat mailem",
        da: "Sende via e-mail",
        de: "Per E-Mail versenden",
        en: "Send by email",
        es: "Enviar por email",
        fi: "Lähetä sähköpostitse",
        fr: "Envoyer par courriel",
        hr: "Pošaljite emailom",
        hu: "Elküldés e-mailben",
        it: "Inviare via email",
        ja: "電子メールで送信",
        ko: "이메일로 보내기",
        nl: "Sturen via e-mail",
        no: "Send via epost",
        pl: "Wyślij e-mailem",
        pt: "Enviar por e-mail",
        ro: "Trimite prin e-mail",
        ru: "Отправить по эл. почте",
        sk: "Poslať e-mailom",
        sl: "Pošlji po elektronski pošti",
        sr: "Pošalji putem email-a",
        sv: "Skicka via e-post",
        tr: "E-posta ile gönder",
        zh: "通过电子邮件传送"
      },
      shareUrl: t
    };
  };
}, function (e, t, r) {
  "use strict";

  var a = r(0);

  e.exports = function (e) {
    var t = e.getTitle(),
        r = e.getMeta("DC.creator");
    r.length > 0 && (t += " - " + r);
    var n = e.getOption("mediaUrl");
    (!n || n.length <= 0) && (n = e.getMeta("og:image"));
    var i = a.parse("https://www.pinterest.com/pin/create/link/", !0);
    return i.query.url = e.getURL(), i.query.media = n, i.query.description = t, delete i.search, {
      popup: !0,
      shareText: "pin it",
      name: "pinterest",
      faPrefix: "fab",
      faName: "fa-pinterest-p",
      title: {
        bg: "Сподели в Pinterest",
        cs: "Přidat na Pinterest",
        da: "Del på Pinterest",
        de: "Bei Pinterest pinnen",
        en: "Pin it on Pinterest",
        es: "Compartir en Pinterest",
        fi: "Jaa Pinterestissä",
        fr: "Partager sur Pinterest",
        hr: "Podijelite na Pinterest",
        hu: "Megosztás Pinteresten",
        it: "Condividi su Pinterest",
        ja: "Pinterest上で共有",
        ko: "Pinterest에서 공유하기",
        nl: "Delen op Pinterest",
        no: "Del på Pinterest",
        pl: "Udostępnij przez Pinterest",
        pt: "Compartilhar no Pinterest",
        ro: "Partajează pe Pinterest",
        ru: "Поделиться на Pinterest",
        sk: "Zdieľať na Pinterest",
        sl: "Deli na Pinterest",
        sr: "Podeli na Pinterest-u",
        sv: "Dela på Pinterest",
        tr: "Pinterest'ta paylaş",
        zh: "分享至Pinterest"
      },
      shareUrl: a.format(i) + e.getReferrerTrack()
    };
  };
}, function (e, t, r) {
  "use strict";

  e.exports = function (e) {
    return {
      name: "print",
      faPrefix: "fas",
      faName: "fa-print",
      popup: !1,
      shareText: {
        bg: "",
        cs: "tlačit",
        da: "",
        de: "drucken",
        en: "print",
        es: "",
        fi: "",
        fr: "",
        hr: "",
        hu: "",
        it: "",
        ja: "",
        ko: "",
        nl: "",
        no: "",
        pl: "",
        pt: "",
        ro: "",
        ru: "",
        sk: "",
        sl: "",
        sr: "",
        sv: "",
        tr: "",
        zh: ""
      },
      title: {
        bg: "",
        cs: "tlačit",
        da: "",
        de: "drucken",
        en: "print",
        es: "",
        fi: "",
        fr: "",
        hr: "",
        hu: "",
        it: "",
        ja: "",
        ko: "",
        nl: "",
        no: "",
        pl: "",
        pt: "",
        ro: "",
        ru: "",
        sk: "",
        sl: "",
        sr: "",
        sv: "",
        tr: "",
        zh: ""
      },
      shareUrl: "javascript:window.print();"
    };
  };
}, function (e, t, r) {
  "use strict";

  e.exports = function (e) {
    return {
      popup: !0,
      shareText: {
        bg: "cподеляне",
        cs: "sdílet",
        da: "del",
        de: "teilen",
        en: "share",
        es: "compartir",
        fi: "Jaa",
        fr: "partager",
        hr: "podijelite",
        hu: "megosztás",
        it: "condividi",
        ja: "共有",
        ko: "공유하기",
        nl: "delen",
        no: "del",
        pl: "udostępnij",
        pt: "compartilhar",
        ro: "partajează",
        ru: "поделиться",
        sk: "zdieľať",
        sl: "deli",
        sr: "podeli",
        sv: "dela",
        tr: "paylaş",
        zh: "分享"
      },
      name: "qzone",
      faPrefix: "fab",
      faName: "fa-qq",
      title: {
        bg: "Сподели в Qzone",
        cs: "Sdílet na Qzone",
        da: "Del på Qzone",
        de: "Bei Qzone teilen",
        en: "Share on Qzone",
        es: "Compartir en Qzone",
        fi: "Jaa Qzoneissä",
        fr: "Partager sur Qzone",
        hr: "Podijelite na Qzone",
        hu: "Megosztás Qzone",
        it: "Condividi su Qzone",
        ja: "Qzone上で共有",
        ko: "Qzone에서 공유하기",
        nl: "Delen op Qzone",
        no: "Del på Qzone",
        pl: "Udostępnij przez Qzone",
        pt: "Compartilhar no Qzone",
        ro: "Partajează pe Qzone",
        ru: "Поделиться на Qzone",
        sk: "Zdieľať na Qzone",
        sl: "Deli na Qzone",
        sr: "Podeli na Qzone-u",
        sv: "Dela på Qzone",
        tr: "Qzone'ta paylaş",
        zh: "分享至QQ空间"
      },
      shareUrl: "http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" + encodeURIComponent(e.getURL()) + "&title=" + e.getTitle() + e.getReferrerTrack()
    };
  };
}, function (e, t, r) {
  "use strict";

  e.exports = function (e) {
    var t = encodeURIComponent(e.getURL()),
        r = encodeURIComponent(e.getTitle());
    return "" !== r && (r = "&title=" + r), {
      popup: !0,
      shareText: {
        bg: "cподеляне",
        cs: "sdílet",
        da: "del",
        de: "teilen",
        en: "share",
        es: "compartir",
        fi: "Jaa",
        fr: "partager",
        hr: "podijelite",
        hu: "megosztás",
        it: "condividi",
        ja: "共有",
        ko: "공유하기",
        nl: "delen",
        no: "del",
        pl: "udostępnij",
        pt: "compartilhar",
        ro: "partajează",
        ru: "поделиться",
        sk: "zdieľať",
        sl: "deli",
        sr: "podeli",
        sv: "dela",
        tr: "paylaş",
        zh: "分享"
      },
      name: "reddit",
      faPrefix: "fab",
      faName: "fa-reddit-alien",
      title: {
        bg: "Сподели в Reddit",
        cs: "Sdílet na Redditu",
        da: "Del på Reddit",
        de: "Bei Reddit teilen",
        en: "Share on Reddit",
        es: "Compartir en Reddit",
        fi: "Jaa Redditissä",
        fr: "Partager sur Reddit",
        hr: "Podijelite na Reddit",
        hu: "Megosztás Redditen",
        it: "Condividi su Reddit",
        ja: "Reddit上で共有",
        ko: "Reddit에서 공유하기",
        nl: "Delen op Reddit",
        no: "Del på Reddit",
        pl: "Udostępnij przez Reddit",
        pt: "Compartilhar no Reddit",
        ro: "Partajează pe Reddit",
        ru: "Поделиться на Reddit",
        sk: "Zdieľať na Reddit",
        sl: "Deli na Reddit",
        sr: "Podeli na Reddit-u",
        sv: "Dela på Reddit",
        tr: "Reddit'ta paylaş",
        zh: "分享至Reddit"
      },
      shareUrl: "https://reddit.com/submit?url=" + t + r + e.getReferrerTrack()
    };
  };
}, function (e, t, r) {
  "use strict";

  e.exports = function (e) {
    var t = encodeURIComponent(e.getURL()),
        r = encodeURIComponent(e.getTitle());
    return "" !== r && (r = "&title=" + r), {
      popup: !0,
      shareText: {
        bg: "cподеляне",
        cs: "sdílet",
        da: "del",
        de: "teilen",
        en: "share",
        es: "compartir",
        fi: "Jaa",
        fr: "partager",
        hr: "podijelite",
        hu: "megosztás",
        it: "condividi",
        ja: "共有",
        ko: "공유하기",
        nl: "delen",
        no: "del",
        pl: "udostępnij",
        pt: "compartilhar",
        ro: "partajează",
        ru: "поделиться",
        sk: "zdieľať",
        sl: "deli",
        sr: "podeli",
        sv: "dela",
        tr: "paylaş",
        zh: "分享"
      },
      name: "stumbleupon",
      faPrefix: "fab",
      faName: "fa-stumbleupon",
      title: {
        bg: "Сподели в Stumbleupon",
        cs: "Sdílet na Stumbleuponu",
        da: "Del på Stumbleupon",
        de: "Bei Stumbleupon teilen",
        en: "Share on Stumbleupon",
        es: "Compartir en Stumbleupon",
        fi: "Jaa Stumbleuponissä",
        fr: "Partager sur Stumbleupon",
        hr: "Podijelite na Stumbleupon",
        hu: "Megosztás Stumbleupon",
        it: "Condividi su Stumbleupon",
        ja: "Stumbleupon上で共有",
        ko: "Stumbleupon에서 공유하기",
        nl: "Delen op Stumbleupon",
        no: "Del på Stumbleupon",
        pl: "Udostępnij przez Stumbleupon",
        pt: "Compartilhar no Stumbleupon",
        ro: "Partajează pe Stumbleupon",
        ru: "Поделиться на Stumbleupon",
        sk: "Zdieľať na Stumbleupon",
        sl: "Deli na Stumbleupon",
        sr: "Podeli na Stumbleupon-u",
        sv: "Dela på Stumbleupon",
        tr: "Stumbleupon'ta paylaş",
        zh: "分享至Stumbleupon"
      },
      shareUrl: "https://www.stumbleupon.com/submit?url=" + t + r + e.getReferrerTrack()
    };
  };
}, function (e, t, r) {
  "use strict";

  e.exports = function (e) {
    return {
      popup: !0,
      shareText: {
        bg: "cподеляне",
        cs: "sdílet",
        da: "del",
        de: "teilen",
        en: "share",
        es: "compartir",
        fi: "Jaa",
        fr: "partager",
        hr: "podijelite",
        hu: "megosztás",
        it: "condividi",
        ja: "共有",
        ko: "공유하기",
        nl: "delen",
        no: "del",
        pl: "udostępnij",
        pt: "compartilhar",
        ro: "partajează",
        ru: "поделиться",
        sk: "zdieľať",
        sl: "deli",
        sr: "podeli",
        sv: "dela",
        tr: "paylaş",
        zh: "分享"
      },
      name: "telegram",
      faPrefix: "fab",
      faName: "fa-telegram",
      title: {
        bg: "Сподели в Telegram",
        cs: "Sdílet na Telegramu",
        da: "Del på Telegram",
        de: "Bei Telegram teilen",
        en: "Share on Telegram",
        es: "Compartir en Telegram",
        fi: "Jaa Telegramissä",
        fr: "Partager sur Telegram",
        hr: "Podijelite na Telegram",
        hu: "Megosztás Telegramen",
        it: "Condividi su Telegram",
        ja: "Telegram上で共有",
        ko: "Telegram에서 공유하기",
        nl: "Delen op Telegram",
        no: "Del på Telegram",
        pl: "Udostępnij przez Telegram",
        pt: "Compartilhar no Telegram",
        ro: "Partajează pe Telegram",
        ru: "Поделиться на Telegram",
        sk: "Zdieľať na Telegram",
        sl: "Deli na Telegram",
        sr: "Podeli na Telegram-u",
        sv: "Dela på Telegram",
        tr: "Telegram'ta paylaş",
        zh: "在Telegram上分享"
      },
      shareUrl: "https://t.me/share/url?url=" + encodeURIComponent(e.getURL()) + e.getReferrerTrack()
    };
  };
}, function (e, t, r) {
  "use strict";

  e.exports = function (e) {
    return {
      popup: !0,
      shareText: {
        bg: "cподеляне",
        cs: "sdílet",
        da: "del",
        de: "teilen",
        en: "share",
        es: "compartir",
        fi: "Jaa",
        fr: "partager",
        hr: "podijelite",
        hu: "megosztás",
        it: "condividi",
        ja: "共有",
        ko: "공유하기",
        nl: "delen",
        no: "del",
        pl: "udostępnij",
        pt: "compartilhar",
        ro: "partajează",
        ru: "поделиться",
        sk: "zdieľať",
        sl: "deli",
        sr: "podeli",
        sv: "dela",
        tr: "paylaş",
        zh: "分享"
      },
      name: "tencent-weibo",
      faPrefix: "fab",
      faName: "fa-tencent-weibo",
      title: {
        bg: "Сподели в tencent weibo",
        cs: "Sdílet na tencent weibo",
        da: "Del på tencent weibo",
        de: "Bei tencent weibo teilen",
        en: "Share on tencent weibo",
        es: "Compartir en tencent weibo",
        fi: "Jaa tencent weiboissä",
        fr: "Partager sur tencent weibo",
        hr: "Podijelite na tencent weibo",
        hu: "Megosztás tencent weiboen",
        it: "Condividi su tencent weibo",
        ja: "Tencent weibo上で共有",
        ko: "Tencent weibo에서 공유하기",
        nl: "Delen op tencent weibo",
        no: "Del på tencent weibo",
        pl: "Udostępnij przez tencent weibo",
        pt: "Compartilhar no tencent weibo",
        ro: "Partajează pe tencent weibo",
        ru: "Поделиться на tencent weibo",
        sk: "Zdieľať na tencent weibo",
        sl: "Deli na tencent weibo",
        sr: "Podeli na tencent weibo-u",
        sv: "Dela på tencent weibo",
        tr: "Tencent weibo'ta paylaş",
        zh: "分享至腾讯微博"
      },
      shareUrl: "http://v.t.qq.com/share/share.php?url=" + encodeURIComponent(e.getURL()) + "&title=" + e.getTitle() + e.getReferrerTrack()
    };
  };
}, function (e, t, r) {
  "use strict";

  e.exports = function (e) {
    var t = encodeURIComponent(e.getURL()),
        r = e.getTitle();
    return {
      popup: !1,
      shareText: {
        bg: "cподеляне",
        cs: "sdílet",
        da: "del",
        de: "teilen",
        en: "share",
        es: "compartir",
        fi: "Jaa",
        fr: "partager",
        hr: "podijelite",
        hu: "megosztás",
        it: "condividi",
        ja: "共有",
        ko: "공유하기",
        nl: "delen",
        no: "del",
        pl: "udostępnij",
        pt: "compartilhar",
        ro: "partajează",
        ru: "поделиться",
        sk: "zdieľať",
        sl: "deli",
        sr: "podeli",
        sv: "dela",
        tr: "paylaş",
        zh: "分享"
      },
      name: "threema",
      faPrefix: "fas",
      faName: "fa-lock",
      title: {
        bg: "Сподели в Threema",
        cs: "Sdílet na Threema",
        da: "Del på Threema",
        de: "Bei Threema teilen",
        en: "Share on Threema",
        es: "Compartir en Threema",
        fi: "Jaa Threemaissä",
        fr: "Partager sur Threema",
        hr: "Podijelite na Threema",
        hu: "Megosztás Threemaen",
        it: "Condividi su Threema",
        ja: "Threema上で共有",
        ko: "Threema에서 공유하기",
        nl: "Delen op Threema",
        no: "Del på Threema",
        pl: "Udostępnij przez Threema",
        pt: "Compartilhar no Threema",
        ro: "Partajează pe Threema",
        ru: "Поделиться на Threema",
        sk: "Zdieľať na Threema",
        sl: "Deli na Threema",
        sr: "Podeli na Threema-u",
        sv: "Dela på Threema",
        tr: "Threema'ta paylaş",
        zh: "在Threema上分享"
      },
      shareUrl: "threema://compose?text=" + encodeURIComponent(r) + "%20" + t + e.getReferrerTrack()
    };
  };
}, function (e, t, r) {
  "use strict";

  e.exports = function (e) {
    return {
      popup: !0,
      shareText: {
        bg: "cподеляне",
        cs: "sdílet",
        da: "del",
        de: "teilen",
        en: "share",
        es: "compartir",
        fi: "Jaa",
        fr: "partager",
        hr: "podijelite",
        hu: "megosztás",
        it: "condividi",
        ja: "共有",
        ko: "공유하기",
        nl: "delen",
        no: "del",
        pl: "udostępnij",
        pt: "compartilhar",
        ro: "partajează",
        ru: "поделиться",
        sk: "zdieľať",
        sl: "deli",
        sr: "podeli",
        sv: "dela",
        tr: "paylaş",
        zh: "分享"
      },
      name: "tumblr",
      faPrefix: "fab",
      faName: "fa-tumblr",
      title: {
        bg: "Сподели в tumblr",
        cs: "Sdílet na tumblru",
        da: "Del på tumblr",
        de: "Bei tumblr teilen",
        en: "Share on tumblr",
        es: "Compartir en tumblr",
        fi: "Jaa tumblrissä",
        fr: "Partager sur tumblr",
        hr: "Podijelite na tumblr",
        hu: "Megosztás tumblren",
        it: "Condividi su tumblr",
        ja: "tumblr上で共有",
        ko: "tumblr에서 공유하기",
        nl: "Delen op tumblr",
        no: "Del på tumblr",
        pl: "Udostępnij przez tumblr",
        pt: "Compartilhar no tumblr",
        ro: "Partajează pe tumblr",
        ru: "Поделиться на tumblr",
        sk: "Zdieľať na tumblr",
        sl: "Deli na tumblr",
        sr: "Podeli na tumblr-u",
        sv: "Dela på tumblr",
        tr: "tumblr'ta paylaş",
        zh: "在tumblr上分享"
      },
      shareUrl: "http://tumblr.com/widgets/share/tool?canonicalUrl=" + encodeURIComponent(e.getURL()) + e.getReferrerTrack()
    };
  };
}, function (e, t, r) {
  "use strict";

  var a = r(0),
      n = function n(e, t) {
    var r = document.createElement("div"),
        a = document.createTextNode(e);
    r.appendChild(a);
    var n = r.textContent;
    if (n.length <= t) return e;
    var i = n.substring(0, t - 1).lastIndexOf(" ");
    return n = n.substring(0, i) + "…";
  };

  e.exports = function (e) {
    var t = a.parse("https://twitter.com/intent/tweet", !0),
        r = e.getTitle();
    return t.query.text = n(r, 120), t.query.url = e.getURL(), null !== e.options.twitterVia && (t.query.via = e.options.twitterVia), delete t.search, {
      popup: !0,
      shareText: {
        en: "tweet",
        ja: "のつぶやき",
        ko: "짹짹",
        ru: "твит",
        sr: "твеет",
        zh: "鸣叫"
      },
      name: "twitter",
      faPrefix: "fab",
      faName: "fa-twitter",
      title: {
        bg: "Сподели в Twitter",
        cs: "Sdílet na Twiiteru",
        da: "Del på Twitter",
        de: "Bei Twitter teilen",
        en: "Share on Twitter",
        es: "Compartir en Twitter",
        fi: "Jaa Twitterissä",
        fr: "Partager sur Twitter",
        hr: "Podijelite na Twitteru",
        hu: "Megosztás Twitteren",
        it: "Condividi su Twitter",
        ja: "ツイッター上で共有",
        ko: "트위터에서 공유하기",
        nl: "Delen op Twitter",
        no: "Del på Twitter",
        pl: "Udostępnij na Twitterze",
        pt: "Compartilhar no Twitter",
        ro: "Partajează pe Twitter",
        ru: "Поделиться на Twitter",
        sk: "Zdieľať na Twitteri",
        sl: "Deli na Twitterju",
        sr: "Podeli na Twitter-u",
        sv: "Dela på Twitter",
        tr: "Twitter'da paylaş",
        zh: "在Twitter上分享"
      },
      shareUrl: a.format(t) + e.getReferrerTrack()
    };
  };
}, function (e, t, r) {
  "use strict";

  e.exports = function (e) {
    return {
      popup: !0,
      shareText: {
        bg: "cподеляне",
        cs: "sdílet",
        da: "del",
        de: "teilen",
        en: "share",
        es: "compartir",
        fi: "Jaa",
        fr: "partager",
        hr: "podijelite",
        hu: "megosztás",
        it: "condividi",
        ja: "共有",
        ko: "공유하기",
        nl: "delen",
        no: "del",
        pl: "udostępnij",
        pt: "compartilhar",
        ro: "partajează",
        ru: "поделиться",
        sk: "zdieľať",
        sl: "deli",
        sr: "podeli",
        sv: "dela",
        tr: "paylaş",
        zh: "分享"
      },
      name: "vk",
      faPrefix: "fab",
      faName: "fa-vk",
      title: {
        bg: "Сподели във VK",
        cs: "Sdílet na VKu",
        da: "Del på VK",
        de: "Bei VK teilen",
        en: "Share on VK",
        es: "Compartir en VK",
        fi: "Jaa VKissa",
        fr: "Partager sur VK",
        hr: "Podijelite na VKu",
        hu: "Megosztás VKon",
        it: "Condividi su VK",
        ja: "フェイスブック上で共有",
        ko: "페이스북에서 공유하기",
        nl: "Delen op VK",
        no: "Del på VK",
        pl: "Udostępnij na VKu",
        pt: "Compartilhar no VK",
        ro: "Partajează pe VK",
        ru: "Поделиться на ВКонтакте",
        sk: "Zdieľať na VKu",
        sl: "Deli na VKu",
        sr: "Podeli na VK-u",
        sv: "Dela på VK",
        tr: "VK'ta paylaş",
        zh: "在VK上分享"
      },
      shareUrl: "https://vk.com/share.php?url=" + encodeURIComponent(e.getURL()) + e.getReferrerTrack()
    };
  };
}, function (e, t, r) {
  "use strict";

  e.exports = function (e) {
    return {
      popup: !0,
      shareText: {
        bg: "cподеляне",
        cs: "sdílet",
        da: "del",
        de: "teilen",
        en: "share",
        es: "compartir",
        fi: "Jaa",
        fr: "partager",
        hr: "podijelite",
        hu: "megosztás",
        it: "condividi",
        ja: "共有",
        ko: "공유하기",
        nl: "delen",
        no: "del",
        pl: "udostępnij",
        pt: "compartilhar",
        ro: "partajează",
        ru: "поделиться",
        sk: "zdieľať",
        sl: "deli",
        sr: "podeli",
        sv: "dela",
        tr: "paylaş",
        zh: "分享"
      },
      name: "weibo",
      faPrefix: "fab",
      faName: "fa-weibo",
      title: {
        bg: "Сподели в weibo",
        cs: "Sdílet na weibo",
        da: "Del på weibo",
        de: "Bei weibo teilen",
        en: "Share on weibo",
        es: "Compartir en weibo",
        fi: "Jaa weiboissä",
        fr: "Partager sur weibo",
        hr: "Podijelite na weibo",
        hu: "Megosztás weiboen",
        it: "Condividi su weibo",
        ja: "Weibo上で共有",
        ko: "Weibo에서 공유하기",
        nl: "Delen op weibo",
        no: "Del på weibo",
        pl: "Udostępnij przez weibo",
        pt: "Compartilhar no weibo",
        ro: "Partajează pe weibo",
        ru: "Поделиться на weibo",
        sk: "Zdieľať na weibo",
        sl: "Deli na weibo",
        sr: "Podeli na weibo-u",
        sv: "Dela på weibo",
        tr: "Weibo'ta paylaş",
        zh: "分享至新浪微博"
      },
      shareUrl: "http://service.weibo.com/share/share.php?url=" + encodeURIComponent(e.getURL()) + "&title=" + e.getTitle() + e.getReferrerTrack()
    };
  };
}, function (e, t, r) {
  "use strict";

  e.exports = function (e) {
    var t = encodeURIComponent(e.getURL()),
        r = e.getTitle();
    return {
      popup: !1,
      shareText: {
        bg: "cподеляне",
        cs: "sdílet",
        da: "del",
        de: "teilen",
        en: "share",
        es: "compartir",
        fi: "Jaa",
        fr: "partager",
        hr: "podijelite",
        hu: "megosztás",
        it: "condividi",
        ja: "共有",
        ko: "공유하기",
        nl: "delen",
        no: "del",
        pl: "udostępnij",
        pt: "compartilhar",
        ro: "partajează",
        ru: "поделиться",
        sk: "zdieľať",
        sl: "deli",
        sr: "podeli",
        sv: "dela",
        tr: "paylaş",
        zh: "分享"
      },
      name: "whatsapp",
      faPrefix: "fab",
      faName: "fa-whatsapp",
      title: {
        bg: "Сподели в Whatsapp",
        cs: "Sdílet na Whatsappu",
        da: "Del på Whatsapp",
        de: "Bei Whatsapp teilen",
        en: "Share on Whatsapp",
        es: "Compartir en Whatsapp",
        fi: "Jaa WhatsAppissä",
        fr: "Partager sur Whatsapp",
        hr: "Podijelite na Whatsapp",
        hu: "Megosztás WhatsAppen",
        it: "Condividi su Whatsapp",
        ja: "Whatsapp上で共有",
        ko: "Whatsapp에서 공유하기",
        nl: "Delen op Whatsapp",
        no: "Del på Whatsapp",
        pl: "Udostępnij przez WhatsApp",
        pt: "Compartilhar no Whatsapp",
        ro: "Partajează pe Whatsapp",
        ru: "Поделиться на Whatsapp",
        sk: "Zdieľať na Whatsapp",
        sl: "Deli na Whatsapp",
        sr: "Podeli na WhatsApp-u",
        sv: "Dela på Whatsapp",
        tr: "Whatsapp'ta paylaş",
        zh: "在Whatsapp上分享"
      },
      shareUrl: "whatsapp://send?text=" + encodeURIComponent(r) + "%20" + t + e.getReferrerTrack()
    };
  };
}, function (e, t, r) {
  "use strict";

  e.exports = function (e) {
    return {
      popup: !0,
      shareText: {
        bg: "cподеляне",
        cs: "sdílet",
        da: "del",
        de: "teilen",
        en: "share",
        es: "compartir",
        fi: "Jaa",
        fr: "partager",
        hr: "podijelite",
        hu: "megosztás",
        it: "condividi",
        ja: "共有",
        ko: "공유하기",
        nl: "delen",
        no: "del",
        pl: "udostępnij",
        pt: "compartilhar",
        ro: "partajează",
        ru: "поделиться",
        sk: "zdieľať",
        sl: "deli",
        sr: "podeli",
        sv: "dela",
        tr: "paylaş",
        zh: "分享"
      },
      name: "xing",
      faPrefix: "fab",
      faName: "fa-xing",
      title: {
        bg: "Сподели в XING",
        cs: "Sdílet na XINGu",
        da: "Del på XING",
        de: "Bei XING teilen",
        en: "Share on XING",
        es: "Compartir en XING",
        fi: "Jaa XINGissä",
        fr: "Partager sur XING",
        hr: "Podijelite na XING",
        hu: "Megosztás XINGen",
        it: "Condividi su XING",
        ja: "XING上で共有",
        ko: "XING에서 공유하기",
        nl: "Delen op XING",
        no: "Del på XING",
        pl: "Udostępnij przez XING",
        pt: "Compartilhar no XING",
        ro: "Partajează pe XING",
        ru: "Поделиться на XING",
        sk: "Zdieľať na XING",
        sl: "Deli na XING",
        sr: "Podeli na XING-u",
        sv: "Dela på XING",
        tr: "XING'ta paylaş",
        zh: "分享至XING"
      },
      shareUrl: "https://www.xing.com/social_plugins/share?url=" + encodeURIComponent(e.getURL()) + e.getReferrerTrack()
    };
  };
}]);
